// extracted by mini-css-extract-plugin
export default {"modal":"WalletFormRequest_modal__-L4bF"};